module.exports = __webpack_public_path__ + "02_face.66a0a85d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer1/02_face.png
// module id = Bvs+
// module chunks = 0